import { Switch } from "@mui/material";
import {
	type GridColDef,
	type GridRenderCellParams,
} from "@mui/x-data-grid-pro";

import type { GroupRule } from "@/components/global/types";

import pages from "../../../../../constants/pages";
import CoAppDataGridDateTimeCell from "../../../../global/components/datagrid/CoAppDataGridDateTimeCell";
import CoAppDataGridNameCell from "../../../../global/components/datagrid/CoAppDataGridNameCell";
import ThreeDotMenu from "../../../../global/components/ThreeDotMenu";
import RuleDataGridLongTextCell from "../../../../rule-library/RuleDataGridLongTextCell";

export const groupRuleColumns = [
	"actions",
	"name",
	"active",
	"updatedAt",
	"createdAt",
	"platform",
];

export interface GroupRulesColumnsProps {
  handleRuleStatusToggle: (ruleId: string, active: boolean) => void;
  removeRuleFromGroup: (ruleId: string) => void;
  navigate: (path: string) => void;
}

export default function GroupRulesColumns({
	handleRuleStatusToggle,
	removeRuleFromGroup,
	navigate,
}: GroupRulesColumnsProps): GridColDef<GroupRule>[] {
	return [
		{
			editable: false,
			field: "name",
			flex: 1,
			sortable: true,
			headerName: "Rule Name",
			pinnable: false,
			renderCell: (params: GridRenderCellParams<GroupRule>) => (
				<CoAppDataGridNameCell item={params.row} />
			),
		},
		{
			field: "platform",
			headerName: "Platform",
			flex: 1,
			sortable: true,
			valueGetter: (params: any) =>
				params?.value ?? params?.row?.platform ?? null,
			renderCell: (params: GridRenderCellParams<GroupRule>) => (
				<RuleDataGridLongTextCell
							value={params.row?.platform?.name || " "}
						/>
			),
		},
		{
			editable: true,
			field: "active",
			headerName: "Status",
			width: 100,
			sortable: true,
			pinnable: false,
			renderCell: (params: GridRenderCellParams<GroupRule>) => (
				<Switch
							checked={params.row.active}
							disabled={false}
							onChange={() =>
								handleRuleStatusToggle(params.row.id, !params.row.active)
							}
						/>
			),
		},
		{
			editable: false,
			field: "updatedAt",
			flex: 1,
			headerName: "Modified",
			sortable: true,
			pinnable: false,
			valueGetter: (params: any) =>
				params.value ? new Date(params.value) : null,
			renderCell: (params: GridRenderCellParams<GroupRule, Date | null>) => (
				<CoAppDataGridDateTimeCell value={params.value} />
			),
		},
		{
			editable: false,
			field: "createdAt",
			flex: 1,
			headerName: "Created",
			sortable: true,
			pinnable: false,
			valueGetter: (params: any) =>
				params.value ? new Date(params.value) : null,
			renderCell: (params: GridRenderCellParams<GroupRule, Date | null>) => (
				<CoAppDataGridDateTimeCell value={params.value} />
			),
		},
		{
			field: "actions",
			disableExport: true,
			type: "actions",
			sortable: false,
			flex: 0.1,
			renderCell: (params: GridRenderCellParams<GroupRule>) => (
				<ThreeDotMenu
							options={[
								{
									name: "Remove From Group",
									optionClickHandler: () =>
										removeRuleFromGroup(params.row.id),
								},
								{
									name: "View Rule",
									optionClickHandler: () =>
										navigate(pages.editRule(params.row.id)),
								},
							]}
						/>
			),
		},
	];
}
